<template>
  <v-container fluid grid-list-md>
    <v-layout justify-center wrap>
      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-toolbar dark color="primary" flat>
            <v-toolbar-title>Tambah Paket Bermain</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                placeholder="Masukkan nama paket"
                outlined
                label="Nama Paket"
                type="text"
                v-model="entrancePackageName"
              ></v-text-field>

              <v-file-input
                label="Gambar"
                placeholder="Pilih Gambar"
                outlined
                accept="image/*"
                v-model="entrancePackageImage"
                @change="onFileChange"
              ></v-file-input>
              <v-img
                max-height="125"
                class="mb-6 text-left"
                contain
                :src="imagePath"
              >
              </v-img>

              <v-select
                v-model="ageType"
                :items="ageTypes"
                menu-props="auto"
                outlined
                placeholder="Kategori Umur"
                item-value="value"
                item-text="label"
                label="Kategori Umur"
              ></v-select>

              <v-textarea
                label="Deskripsi"
                outlined
                placeholder="Masukkan deskripsi"
                v-model="description"
              ></v-textarea>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-toolbar color="white" flat>
            <v-toolbar-title>Harga</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                hint="Harga yang berlaku di hari Senin sampai Jumat"
                persistent-hint
                outlined
                label="Harga Senin - Jumat"
                type="number"
                prefix="Rp."
                class="mb-4"
                v-model="weekdayPrice"
              ></v-text-field>
              <v-text-field
                hint="Harga yang berlaku di hari Sabtu dan Minggu"
                persistent-hint
                outlined
                label="Harga Sabtu dan Minggu"
                type="number"
                prefix="Rp."
                v-model="weekendPrice"
              ></v-text-field>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-toolbar color="white" flat>
            <v-toolbar-title>Periode Aktif</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout wrap justify-space-around>
                <v-flex xs12>
                  <v-switch
                    v-model="isValidForever"
                    label="Aktif Selamanya"
                  ></v-switch>
                </v-flex>

                <v-flex xs12 sm5 md5>
                  <v-expand-transition>
                    <div v-show="!isValidForever">
                      <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            label="Tanggal Mulai"
                            hint="hari awal paket bisa dibeli"
                            persistent-hint
                            prepend-icon="event"
                            v-on="on"
                            readonly
                            :value="validFromFormatted"
                            :disabled="isValidForever"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="validFromDate"
                          @input="menu1 = false"
                        ></v-date-picker>
                      </v-menu>
                    </div>
                  </v-expand-transition>
                </v-flex>
                <v-flex xs12 sm5 md5>
                  <v-expand-transition>
                    <div v-show="!isValidForever">
                      <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            label="Tanggal Akhir"
                            hint="hari terakhir paket bisa dibeli"
                            persistent-hint
                            prepend-icon="event"
                            v-on="on"
                            readonly
                            :value="validUntilFormatted"
                            :disabled="isValidForever"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="validUntilDate"
                          @input="menu2 = false"
                        ></v-date-picker>
                      </v-menu>
                    </div>
                  </v-expand-transition>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-container fluid fill-height>
              <v-layout wrap justify-start>
                <v-flex xs12>
                  <v-divider light></v-divider>
                </v-flex>
                <v-flex xs12 class="text-right">
                  <v-btn color="tertiary" class="mr-4" :to="mainPath" dark
                    >Kembali</v-btn
                  >
                  <v-btn
                    color="secondary"
                    :loading="loading"
                    :disabled="loading"
                    @click="addData"
                    >Tambah<template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 sm10 md10 v-show="false">
        <v-card class="elevation-4">
          <v-card-text>
            <v-form>
              <v-switch
                v-model="hasBalanceAddition"
                label="Tambahan saldo berlaku"
              ></v-switch>
              <v-expand-transition>
                <div v-show="hasBalanceAddition">
                  <v-text-field
                    hint="Tambahan nominal saldo dari pembelian paket ini"
                    persistent-hint
                    outlined
                    label="Tambahan saldo"
                    type="number"
                    v-model="balanceAddition"
                    :disabled="!hasBalanceAddition"
                  ></v-text-field>
                </div>
              </v-expand-transition>

              <v-switch
                v-model="hasBonusAddition"
                label="Tambahan bonus berlaku"
              ></v-switch>
              <v-expand-transition
                ><div v-show="hasBonusAddition">
                  <v-text-field
                    hint="Tambahan nominal bonus dari pembelian paket ini"
                    persistent-hint
                    outlined
                    label="Tambahan bonus"
                    type="number"
                    :disabled="!hasBonusAddition"
                    v-model="bonusAddition"
                  ></v-text-field></div
              ></v-expand-transition>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-container fluid fill-height>
              <v-layout wrap justify-start>
                <v-flex xs12>
                  <v-divider light></v-divider>
                </v-flex>
                <v-flex xs12 class="text-right">
                  <v-btn color="tertiary" class="mr-4" :to="mainPath" dark
                    >Kembali</v-btn
                  >
                  <v-btn
                    color="secondary"
                    :loading="loading"
                    :disabled="loading"
                    @click="addData"
                    >Tambah<template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="isLoadingFinished"
      top
      :color="loadingMessageColor"
      :timeout="errorTimeout"
    >
      <span v-html="loadingMessage"></span>
      <v-btn dark text @click="isLoadingFinished = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      isLoadingFinished: false,
      loadingMessage: null,
      loadingMessageColor: "primary",
      errorTimeout: 7000,
      mainPath: process.env.VUE_APP_ENTRANCEPACKAGE_PATH,
      ageTypePath: process.env.VUE_APP_AGETYPE_PATH,
      imagePath: "",
      menu1: false,
      menu2: false,
      entrancePackageName: null,
      entrancePackageImage: [],
      ageType: null,
      description: null,
      weekdayPrice: null,
      weekendPrice: null,
      isValidForever: false,
      validFromString: null,
      validUntilString: null,
      validFromDate: null,
      validUntilDate: null,
      hasBalanceAddition: false,
      balanceAddition: null,
      hasBonusAddition: false,
      bonusAddition: null,
      ageTypes: []
    };
  },
  computed: {
    validFromFormatted() {
      return this.validFromDate
        ? this.$moment(this.validFromDate).format("DD-MM-YYYY")
        : "";
    },
    validUntilFormatted() {
      return this.validUntilDate
        ? this.$moment(this.validUntilDate).format("DD-MM-YYYY")
        : "";
    }
  },
  methods: {
    addData() {
      this.loading = true;
      this.isLoadingFinished = false;
      let self = this;
      let formData = new FormData();
      if (self.entrancePackageImage) {
        formData.append("entrancePackageImage", self.entrancePackageImage);
      }
      formData.append(
        "entrancePackageMainData",
        new Blob(
          [
            JSON.stringify({
              entrancePackageName: self.entrancePackageName,
              ageType: self.ageType,
              description: self.description,
              weekdayPrice: self.weekdayPrice,
              weekendPrice: self.weekendPrice,
              validForever: self.isValidForever,
              validFromDateString: self.validFromFormatted,
              validUntilDateString: self.validUntilFormatted,
              hasBalanceAddition: self.hasBalanceAddition,
              balanceAddition: self.balanceAddition,
              hasBonusAddition: self.hasBonusAddition,
              bonusAddition: self.bonusAddition
            })
          ],
          {
            type: "application/json"
          }
        )
      );
      this.axios
        .post(self.mainPath, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(function(response) {
          let additionMessage =
            "Sukses menambahkan paket bermain <b>" +
            self.entrancePackageName +
            "</b>. Berikutnya dapat mengatur gratis bermain.";
          self.loadingMessageColor = "primary";
          self.$router.push({
            name: "edit-entrance-package",
            params: {
              id: response.data.id,
              success_addition_message: additionMessage
            }
          });
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
        })
        .finally(function() {
          self.loading = false;
          self.isLoadingFinished = true;
        });
    },
    fetchAgeType() {
      let self = this;
      this.axios
        .get(self.ageTypePath)
        .then(function(response) {
          self.ageTypes = response.data;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    },
    onFileChange(e) {
      var reader = new FileReader();
      reader.onload = e => {
        this.imagePath = e.target.result;
      };
      reader.readAsDataURL(e);
    }
  },
  mounted: function() {
    this.fetchAgeType();
  }
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
